import React, { useEffect } from 'react';
import { Box, List, OptionKey, PaginationBar, SearchInput, SelectDropdown, Text } from '@common-fe/common-fe';

import { useFilters } from '@/utils';

import { PER_PAGE, REPORT_TYPE_OPTIONS } from '../ScheduledReport.types';

import { useGetScheduledInboxReportsQuery } from './queries';
import ScheduledInboxReportItem from './ScheduledInboxReportItem';

interface FilterValues {
  searchString: string;
  reportTypes: OptionKey[];

  startDate: Date | null;
  endDate: Date | null;
  page: number;
  perPage: number;
}
const ScheduledReportsInboxTab = () => {
  const { filtersValues, setFilterValue } = useFilters<FilterValues>(
    {
      searchString: '',
      reportTypes: [],

      startDate: null,
      endDate: null,
      page: 1,
      perPage: PER_PAGE,
    },
    {
      autoClear: true,
    }
  );
  useEffect(() => {
    setFilterValue.page(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { isLoading, total, data } = useGetScheduledInboxReportsQuery({
    searchValue: filtersValues.searchString,
    types: filtersValues.reportTypes,

    page: filtersValues.page,
    perPage: filtersValues.perPage,
  });

  return (
    <Box background="module" round="moduleRound" pad="spacing24" direction="column">
      <Box margin={{ bottom: 'l' }} direction="row" align="center" justify="between">
        <Box>
          <Text weight="bold" color="textBody" size="large" style={{ whiteSpace: 'nowrap' }}>
            Inbox: {total}
          </Text>
        </Box>
        <Box direction="row" justify="end">
          <Box width="180px">
            <SearchInput
              testId="statements-list_search"
              value={filtersValues.searchString}
              onChange={setFilterValue.searchString}
              placeholder="Search"
              hasSearchingHistory
            />
          </Box>
          <Box margin={{ left: 'spacing12' }} width="160px">
            <SelectDropdown
              id="type"
              allMode
              name="type"
              prefix="Type"
              dropdownStyles={{
                minWidth: '250px',
              }}
              values={filtersValues.reportTypes}
              onChangeValues={setFilterValue.reportTypes}
              options={REPORT_TYPE_OPTIONS}
              activeTitle
            />
          </Box>
        </Box>
      </Box>
      <List>
        <List.Header>
          <Box width="35px" />
          <List.Header.Item flex={2}>Name</List.Header.Item>
          <List.Header.Item flex={2}>Generation date </List.Header.Item>
          <List.Header.Item flex={2}>Report type</List.Header.Item>

          <Box width="56px" />
        </List.Header>
      </List>
      <Box direction="column">
        {isLoading ? (
          <List.Preloader count={3} />
        ) : (
          data.map((item) => <ScheduledInboxReportItem key={item.id} {...item} />)
        )}

        {!isLoading && !total && <List.Placeholder />}
      </Box>
      {total > PER_PAGE && (
        <PaginationBar
          page={filtersValues.page}
          total={total}
          pageSize={filtersValues.perPage}
          onChangePage={setFilterValue.page}
          onChangePageSize={setFilterValue.perPage}
        />
      )}
    </Box>
  );
};

export default ScheduledReportsInboxTab;
